<template lang="html">
    <section class="orders-payments">
        <div v-if="order.purchaseOrderNumber != null && order.isPurchaseOrderBtnAvailable" class="bloc-btn-modify">
            <button class="btn btn-modify" @click="updatePayments();">{{ $t("orders.btnOrders.btnModify") }}</button>
        </div>
        <div class="purchase-order">
            <label v-if="order.purchaseOrderNumber == null">{{ $t("orders.labelPurchaseOrder") }}:</label>
            <label v-else> {{ $t("orders.purshaseOrderTitle") }} : </label>
            <input
                :class="{ empty: emptyPurchaseOrder }"
                class="purchase-input"
                v-model="valuePurchaseOrderNumber"
                :disabled="!!dataPurchaseOrderNumber"
            />
            <button class="btn purchase-btn" v-if="order.purchaseOrderNumber == null" @click="purchaseOrder();">
                {{ $t("orders.sendPurchaseOrder") }}
            </button>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import cacheService from "@/services/cache";

export default {
    name: 'orders-payments',
    props: ["dataPurchaseOrderNumber"],
    data() {
        return {
            valuePurchaseOrderNumber: "",
            emptyPurchaseOrder: false
        }
    },
    created() {
        this.valuePurchaseOrderNumber = this.dataPurchaseOrderNumber
    },
    methods: {
        ...mapActions("order", {
            addPurchaseOrder: 'details/addPurchaseOrder'
        }),
        async purchaseOrder() {
            if (this.valuePurchaseOrderNumber) {
                let purchaseOrderData = {
                    "purchaseOrderNumber": this.valuePurchaseOrderNumber,
                    "languageCode": cacheService.getUserLang()
                }
                this.emptyPurchaseOrder = false
                try {
                    const resp = await this.addPurchaseOrder(purchaseOrderData);
                    this.valuePurchaseOrderNumber = resp.purchaseOrderNumber;
                    this.dialogSuccess( this.$t("orders.addPurchaseOrderSuccess") );
                }
                catch (e) {
                    this.dialogError(e);
                }
            } else {
                this.emptyPurchaseOrder = true
            }
        },
        updatePayments() {
            this.order.purchaseOrderNumber = null;
            this.valuePurchaseOrderNumber = null;
        }
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        }),
    },
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";

.orders-payments {
    @extend %primary-text;
    & .purchase {
        &-order {
            & label {
                display: block;
                margin-bottom: 10px;
                font-size: 14px;
                font-family: "oswald-regular", sans-serif;
            }
        }
        &-input {
            width: calc(100% - 120px);
            margin-right: 10px;
            padding: 5px;
            border: 1px solid gray;
            -moz-border-radius: 10px;
            -webkit-border-radius: 10px;
            border-radius: 10px;
            &.empty {
                border-color: red;
            }
        }
        &-btn {
            text-transform: uppercase;
            background-color: $color4;
            border-color: $color4;
        }
    }
}
</style>



// WEBPACK FOOTER //
// order-payments.vue?92e8101c